import { InputNumber } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const DynamicFieldInputNumberDecimal = ({ value, onChange, ...props }) => {
  return (<InputNumber value={value} step="0.01" onChange={onChange} {...props} />);
};

DynamicFieldInputNumberDecimal.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default memo(DynamicFieldInputNumberDecimal);
